import React from "react";
import LoginSignUp from "../Components/Authentication/LoginSign/LoginSignUp";
import Footer from "../Components/Footer/Footer";

const Authentication:React.FC = () => {
  return (
    <>
      <LoginSignUp />
      <Footer/>
    </>
  );
};

export default Authentication;
